var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuyerShieldBorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-774.000000, -393.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(730.914683, 88.914683)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.490079, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.195238, 302.685317)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.400000, 2.400000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.82334624,-0.5 C9.49048946,-0.5 11.5194307,0.185393709 13.8336276,1.49210182 C14.0961091,4.90025239 13.4731983,7.70461081 12.2548094,10.0411587 C11.0794787,12.2951325 9.35111252,14.1157896 7.09964479,15.2473791 C4.36642324,14.1256278 2.62000293,12.3218868 1.42474487,10.1015452 C0.168680881,7.76824902 -0.477319808,4.97272509 -0.499981398,2.03311643 C2.12187203,0.185810294 4.15319665,-0.5 6.82334624,-0.5 L6.82334624,-0.5 Z",
  id: "Path",
  stroke: "#FFFFFF",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.447022651,6.01707961 L5.52098231,6.01645167 L5.51973694,14.0602903 C2.90535487,12.2619498 1.20164751,9.37043725 0.447022651,6.01707961 Z M13.1994023,6.01721039 C12.4469868,9.36014128 10.7516074,12.2440167 8.1512828,14.0434235 L8.15001412,6.01645167 Z M8.15094905,0.0635925233 C10.1069297,0.257536051 11.7542431,0.892181432 13.5877867,1.92748928 C13.6242426,1.94805415 13.6469107,1.98731436 13.6466788,2.02926202 C13.6431195,2.48608408 13.6241602,2.93935669 13.5898784,3.38780408 L8.15001412,3.38741986 Z M5.51977122,0.0612229663 L5.52098231,3.38741986 L0.0567001401,3.38775098 C0.02244993,2.9393197 0.00352526047,2.48606479 3.74519485e-06,2.02926202 C-0.000335037734,1.98731436 0.0223330588,1.94805415 0.0587889666,1.92748928 C1.89967752,0.887925285 3.55303996,0.252324772 5.51977122,0.0612229663 Z",
  fill: "#241F20"
})))))))));
export default SvgBuyerShieldBorder;